import Category from './Category';
import CategoryRequirements from './CategoryRequirements';

export {
  CategoryRequirements,
};

export default Category;
